var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "store-description-wrapper" }, [
    _setup.description.image
      ? _c("img", {
          attrs: {
            src: require(`@/assets/images/${_setup.description.image}`),
            alt: "store logo",
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("h1", { staticClass: "m-0" }, [
      _vm._v(_vm._s(_setup.description.title)),
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_setup.description.summary))]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "benefit-list" },
      _vm._l(_setup.description.benefits, function (benefit, idx) {
        return _c("li", { key: `benefit-${idx}` }, [
          _c(
            "span",
            { staticClass: "benefit-icon" },
            [_c("font-awesome-icon", { attrs: { icon: "fa-solid fa-check" } })],
            1
          ),
          _vm._v("\n            " + _vm._s(benefit) + "\n        "),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "review-container mt-3" },
      _vm._l(_setup.description.reviews, function (review, idx) {
        return _c("div", { key: `review-${idx}`, staticClass: "review" }, [
          _c("div", { staticClass: "color-yellow" }, [_vm._v("★★★★★")]),
          _vm._v(" "),
          _c("div", { staticClass: "font-italic my-2" }, [
            _vm._v('"' + _vm._s(review.content) + '"'),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-author" }, [
            _c("img", {
              attrs: {
                src: require(`@/assets/images/reviews/${review.avatar}`),
                alt: review.store,
              },
            }),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "review-store" }, [
                _vm._v(_vm._s(review.store)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "review-country" }, [
                _vm._v(_vm._s(review.country)),
              ]),
            ]),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }